export default __webpack_public_path__ + "static/media/stars-emoji.e571e7ea.svg";